import { Directive, forwardRef, HostBinding, Input } from '@angular/core';

import { KH_A11Y_TARGET } from '../constants/a11y-target.token';
import { A11yLabelTarget } from '../interfaces/a11y.interfaces';
import { addAriaId, normalizeAriaIdList, normalizeAriaValue, removeAriaId } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yLabel]',
  providers: [{ provide: KH_A11Y_TARGET, useExisting: forwardRef(() => A11yLabelDirective) }]
})
export class A11yLabelDirective implements A11yLabelTarget {
  private readonly labelledByIds: string[] = [];
  private readonly describedByIds: string[] = [];

  @Input('khA11yLabel') public a11yLabel: string | null = null;
  @Input() public a11yLabelledBy: string | null = null;
  @Input() public a11yDescribedBy: string | null = null;

  protected get ariaLabelValue(): string | null {
    return this.a11yLabel;
  }

  protected get ariaLabelledByValue(): string | null {
    return this.a11yLabelledBy;
  }

  protected get ariaDescribedByValue(): string | null {
    return this.a11yDescribedBy;
  }

  @HostBinding('attr.aria-label')
  public get ariaLabel(): string | null {
    return this.ariaLabelledBy ? null : normalizeAriaValue(this.ariaLabelValue);
  }

  @HostBinding('attr.aria-labelledby')
  public get ariaLabelledBy(): string | null {
    return normalizeAriaValue(this.ariaLabelledByValue) ?? normalizeAriaIdList(this.labelledByIds);
  }

  @HostBinding('attr.aria-describedby')
  public get ariaDescribedBy(): string | null {
    return normalizeAriaValue(this.ariaDescribedByValue) ?? normalizeAriaIdList(this.describedByIds);
  }

  public registerLabel(id: string): void {
    addAriaId(this.labelledByIds, id);
  }

  public unregisterLabel(id: string): void {
    removeAriaId(this.labelledByIds, id);
  }

  public registerDescription(id: string): void {
    addAriaId(this.describedByIds, id);
  }

  public unregisterDescription(id: string): void {
    removeAriaId(this.describedByIds, id);
  }
}
